import React from 'react';
import { Download, BarChart, TrendingUp, Users } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
export function CommitteeReports() {
  const reports = [{
    title: 'Organization Performance Report Q4 2024',
    date: 'December 2024',
    type: 'PDF'
  }, {
    title: 'Chapter Activity Summary 2024',
    date: 'December 2024',
    type: 'Excel'
  }, {
    title: 'Financial Overview 2024',
    date: 'December 2024',
    type: 'PDF'
  }, {
    title: 'Member Growth Analysis',
    date: 'November 2024',
    type: 'PDF'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1992">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1993">
        <div className="flex items-center justify-between mb-8" data-id="element-1994">
          <div data-id="element-1995">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1996">
              Committee Reports
            </h1>
            <p className="text-neutral-600" data-id="element-1997">
              Organization-wide reports and analytics
            </p>
          </div>
          <Button data-id="element-1998">
            <Download className="w-4 h-4 mr-2" data-id="element-1999" />
            Generate Report
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2000">
          {[{
          label: 'Active Chapters',
          value: '12',
          icon: Users
        }, {
          label: 'Total Members',
          value: '2,450',
          icon: Users
        }, {
          label: 'Annual Growth',
          value: '+23%',
          icon: TrendingUp
        }].map((stat, i) => <Card key={i} data-id="element-2001">
              <CardContent className="p-6" data-id="element-2002">
                <div className="flex items-center gap-4" data-id="element-2003">
                  <div className="p-3 rounded-lg bg-atios-light" data-id="element-2004">
                    <stat.icon className="w-6 h-6 text-atios-primary" data-id="element-2005" />
                  </div>
                  <div data-id="element-2006">
                    <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-2007">
                      {stat.value}
                    </h3>
                    <p className="text-sm text-neutral-600" data-id="element-2008">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <Card data-id="element-2009">
          <CardHeader data-id="element-2010">
            <CardTitle data-id="element-2011">Available Reports</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2012">
            <div className="space-y-4" data-id="element-2013">
              {reports.map((report, i) => <div key={i} className="flex items-center justify-between p-4 border border-neutral-200 rounded-lg hover:border-atios-primary transition-colors" data-id="element-2014">
                  <div data-id="element-2015">
                    <h4 className="font-medium text-neutral-900" data-id="element-2016">
                      {report.title}
                    </h4>
                    <p className="text-sm text-neutral-600" data-id="element-2017">
                      {report.date} • {report.type}
                    </p>
                  </div>
                  <Button variant="secondary" size="sm" data-id="element-2018">
                    <Download className="w-4 h-4 mr-2" data-id="element-2019" />
                    Download
                  </Button>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}